import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7006Model } from '../kymw7006.model';
import { FeatureCandidateGoods } from '../vo/feature-candidate-goods.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

// レスポンス構造
type GetFeatureCandidateGoodsListResponse = {
  OrderCode: string;
  MediumType: string;
  MediumTypeName: string;
  FeatureCode: string;
  FeatureName: string;
  ClassCode: string;
  ClassCodeName: string;
  MiddleClassCode: string;
  MiddleClassCodeName: string;
  PCode: string;
  GuideGoodsName: string;
  GuideStandardName: string;
  ThisTimeSupplyPrice: number;
  PricePattern: number;
  PricePatternName: string;
  PlanNumAiPrediction: number;
  PlanNum: number;
  PlanSupplyBudget: number;
  ThisTimeCostPrice: number;
  Gpr: number;
  RequestBuyerUserId: string;
  RequestBuyerUserName: string;
  Remarks: string;
}[];

/**
 * 特集候補商品一覧情報取得サービス
 * @export GetFeatureCandidateGoodsListService
 * @class GetFeatureCandidateGoodsListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetFeatureCandidateGoodsListService extends PlessJsonResponderSub<GetFeatureCandidateGoodsListResponse> {
  model: KYMW7006Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureCandidateGoodsListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.orderCode,
        MediumType: this.model.mediumType,
        FeatureCode: this.model.featureCode,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetFeatureCandidateGoodsListService
   */
  execute(model: KYMW7006Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('getFeatureCandidateGoodsList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureCandidateGoodsListService
   */
  success(data: GetFeatureCandidateGoodsListResponse) {
    this.model.featureCandidateGoodsList = data.map(_ => new FeatureCandidateGoods(
      _.OrderCode,
      _.MediumType,
      _.MediumTypeName,
      _.FeatureCode,
      _.FeatureName,
      PlessViewUtilsSub.toDisplayCodeAndName(_.FeatureCode, _.FeatureName),
      _.ClassCode,
      _.ClassCodeName,
      PlessViewUtilsSub.toDisplayCodeAndName(_.ClassCode, _.ClassCodeName),
      _.MiddleClassCode,
      _.MiddleClassCodeName,
      PlessViewUtilsSub.toDisplayCodeAndName(_.MiddleClassCode, _.MiddleClassCodeName),
      _.PCode,
      _.GuideGoodsName,
      _.GuideStandardName,
      _.ThisTimeSupplyPrice,
      _.PricePattern,
      _.PricePatternName,
      _.PlanNumAiPrediction,
      _.PlanNum,
      _.PlanSupplyBudget,
      this.model.setDispPlanSupplyBudget(_.PlanSupplyBudget),
      _.ThisTimeCostPrice,
      _.Gpr,
      _.RequestBuyerUserId,
      _.RequestBuyerUserName,
      _.Remarks,
    ));
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
